/**
 * Action Key Constants
 *
 * Single source of truth for all action keys used in transitions.
 * Prevents typos and ensures consistency across:
 * - BlockTransitionManager
 * - ScreenTransitionManager
 * - BlockConverterService
 * - ScreenConverterService
 * - TransitionIdGenerator
 */

// ============================================================================
// BLOCK ACTION KEYS
// ============================================================================

/**
 * Standard action key for block transitions
 * Used in: block.action.edges[]
 */
export const BLOCK_ACTION_KEY = 'action';

// ============================================================================
// SCREEN ACTION KEYS
// ============================================================================

/**
 * Footer button action key
 * Used in: screen.struct.footer.button1.action.edges
 */
export const SCREEN_FOOTER_BUTTON_ACTION_KEY = 'footer.button1';

/**
 * Slider timer action key
 * Used in: screen.struct.slider.timer.action.edges
 */
export const SCREEN_SLIDER_TIMER_ACTION_KEY = 'slider.timer';

/**
 * Generate list item action key
 * Used in: screen.struct.list.items[index].action.edges
 *
 * @param index - List item index
 * @returns Action key in format "list.item.{index}"
 */
export function getScreenListItemActionKey(index: number): string {
  return `list.item.${index}`;
}

/**
 * Parse list item index from action key
 *
 * @param actionKey - Action key in format "list.item.{index}"
 * @returns List item index or undefined if not a list item action key
 */
export function parseListItemIndex(actionKey: string): number | undefined {
  if (!actionKey.startsWith('list.item.')) {
    return undefined;
  }

  const index = parseInt(actionKey.split('.')[2]);
  return isNaN(index) ? undefined : index;
}
